import CresAxios from "../../../../util/CresAxios";
import EnterpriseComponent from "../../EnterpriseComponent";

// The dashboards in this realm, as something PlatformTable can render.
//
// NO IDOC, like ReportResultEnterpriseComponent and the Lookup components before it: the service
// surface is plain JSON on t10/v1/dashboards. A component that wraps an existing surface is the
// established arrangement in this app rather than a departure from it.
//
// AND NO BACKEND EnterpriseComponent EITHER, which is the part worth knowing. Dashboards are a t10
// addition and an EnterpriseComponent's METADATA can only live in the platform core -- so the
// server talks to raw.DASHBOARD in SQL and there is no Dashboard EC in cres/. That is a constraint
// on the SERVER. This is the browser's own EC layer, which is a different thing that happens to
// share a name, and nothing stops a client component wrapping a plain JSON endpoint.
//
// THE WHOLE LIST, UNPAGED, and then paged in memory. A realm has a handful of dashboards -- the
// service returns them in one call with a tile count each -- so asking the server per page would
// be three requests to avoid holding twelve rows.
const URL = "t10/v1/dashboards";

class DashboardEnterpriseComponent extends EnterpriseComponent {

    performQuery = (page, pageSize) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        // PAGE AND PAGE SIZE GO WITH IT. fetchEnterpriseComponentSuccess takes THREE arguments and
        // buffers the rows UNDER THE PAGE NUMBER; called with the object alone they are filed under
        // `undefined` and never become the Maps the grid reads, so the table throws
        // "this.state.buffer[i].get is not a function" -- a runtime blank page that tsc and the
        // production build are both perfectly happy with. Found by loading the page.
        return CresAxios({method: "GET", url: URL})
            .then(response => {
                const list = response?.data?.Dashboards ?? [];
                const results = list.map(one => ({
                    USID: one.USID,
                    Name: one.Name ?? "",
                    Description: one.Description ?? "",
                    // COUNTED AS TEXT, like every other display value in this app's grids: the
                    // server did the counting and a number re-derived in the browser is a second
                    // answer waiting to disagree with the first.
                    Tiles: `${one.TileCount ?? 0}`,
                    // WHERE THIS ROW GOES. Read by the Link Cell renderer, which knows nothing
                    // about dashboards and should not -- see PlatformTable.renderLinkCell.
                    _href: `/dashboards/${one.USID}`,
                }));

                this.fetchEnterpriseComponentSuccess({
                    Count: results.length,
                    Results: results.slice((page - 1) * pageSize, page * pageSize),
                }, page, pageSize);
            })
            // THE GRID MUST NOT BE LEFT SPINNING. A failure here is an empty list with the page's
            // own message above it, not a table that never resolves -- which reads as a hang.
            .catch(() => this.fetchEnterpriseComponentSuccess({Count: 0, Results: []}, page, pageSize));
    };
}

export default DashboardEnterpriseComponent;
